import { Chip } from '@mui/material';
import styled from 'styled-components';
import { muiTheme } from '../../../theme';

export const StyledChip = styled(Chip)<{ $isDarkMode: boolean }>`
  &.MuiChip-filled {
    background-color: ${() => muiTheme.color.backgroundSelectedHover};
  }

  &.MuiChip-colorPrimary:hover {
    background-color: ${({ $isDarkMode }) => ($isDarkMode ? muiTheme.color.white : muiTheme.color.primary)};
    opacity: 0.9;
  }
`;
